import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a5fa2d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-end align-items-center" }
const _hoisted_2 = { class: "form-buttons d-flex justify-content-end align-items-center ms-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  id: "btnSearchSubmit",
  class: "btn btn-icon btn-green ms-0",
  type: "submit"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "mas" }, "search")
], -1))
const _hoisted_4 = {
  key: 1,
  class: "table table-hover align-middle"
}
const _hoisted_5 = { class: "mb-0" }
const _hoisted_6 = { class: "mb-0" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputSelect = _resolveComponent("InputSelect")!
  const _component_dp_form = _resolveComponent("dp-form")!
  const _component_base_title = _resolveComponent("base-title")!
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_container = _resolveComponent("base-container")!

  return (_openBlock(), _createBlock(_component_base_container, { "container-fluid": "" }, {
    default: _withCtx(() => [
      _createVNode(_component_base_title, {
        title: _ctx.$t('allPharmacies'),
        mb: 5,
        "use-router-back": ""
      }, _createSlots({ _: 2 }, [
        (this.isDpUser)
          ? {
              name: "buttons",
              fn: _withCtx(() => [
                _createVNode(_component_dp_form, {
                  onSubmit: this.reloadContent,
                  as: "form",
                  novalidate: "",
                  class: "search-customers-form d-block"
                }, {
                  default: _withCtx(({ errors }) => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_InputText, {
                        modelValue: this.customerCriteria.search_name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((this.customerCriteria.search_name) = $event)),
                        label: `${_ctx.$t('searchCustomer')}...`,
                        name: "search-name",
                        class: "mb-n1",
                        "can-clear": "",
                        errors: errors
                      }, null, 8, ["modelValue", "label", "errors"]),
                      _createVNode(_component_InputSelect, {
                        modelValue: this.customerCriteria.filter_customer_type_code,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.customerCriteria.filter_customer_type_code) = $event)),
                        options: this.optionsCustomerTypeEnum,
                        label: _ctx.$t('type'),
                        name: "product-type",
                        class: "mb-n1 ms-2",
                        style: {"min-width":"fit-content"},
                        "can-clear": "",
                        errors: errors
                      }, null, 8, ["modelValue", "options", "label", "errors"]),
                      _createElementVNode("div", _hoisted_2, [
                        _hoisted_3,
                        _createElementVNode("button", {
                          class: "btn btn-outline-green ms-2",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (this.showAllCustomers && this.showAllCustomers(...args)), ["prevent"]))
                        }, " Toon Alle "),
                        _createElementVNode("button", {
                          class: "btn btn-outline-green ms-2",
                          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (this.showDemoCustomers && this.showDemoCustomers(...args)), ["prevent"]))
                        }, " Toon Demo's ")
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["onSubmit"])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032, ["title"]),
      (!this.isReady)
        ? (_openBlock(), _createBlock(_component_BaseSpinner, {
            key: 0,
            "spinner-class": "mt-5"
          }))
        : _createCommentVNode("", true),
      (this.isReady)
        ? (_openBlock(), _createElementBlock("table", _hoisted_4, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.customerOverview, (customer) => {
                return (_openBlock(), _createElementBlock("tr", {
                  key: customer.customer_code
                }, [
                  _createElementVNode("td", null, [
                    _createElementVNode("p", _hoisted_5, _toDisplayString(customer.name), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(customer.main_license.description), 1)
                  ]),
                  _createElementVNode("td", null, [
                    _createVNode(_component_router_link, {
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#pharmacy-collapse",
                      class: "link py-1 px-2 text-decoration-none d-block btn btn-secondary",
                      to: "/",
                      onClick: ($event: any) => (_ctx.switchCustomer(customer.customer_code))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('select')), 1)
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ])
                ]))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}